import { z } from "zod";
import { translate, getCookie } from "@/assets/utils/utils";

const getMessage = (value) => {
  const lang = getCookie("site_lang") || "en";
  return translate(lang, value);
};

export const ContactSchema = z.object({
  name: z.string().min(1, getMessage("contact_person_not_empty")), // Assuming you need a name validation message
  email: z
    .string()
    .min(1, getMessage("email_address_not_empty"))
    .email(getMessage("email_address_invalid")),
  message: z.string().min(1, getMessage("message_not_empty")),
});
